import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Button from '@material-ui/core/Button';

// CONSTANTS
import { ServiceButtonType } from '@/constants/watchList';

// UTILITY
import { popupCenter, updateUrl } from '@/utility/common';
import { getExternalUrlParams, externalLink } from '@/utility/analytics';

// STORE
import { AuthSelectors } from '@/store/selectors';

const WatchButton = ({ data, partner, analyticsLocation, onWatchNowClick, ...props }) => {
  const unique_id = useSelector(AuthSelectors.getUniqueId);
  const anonymousId = useSelector(AuthSelectors.getAnonymousId);

  const externalUrlParams = getExternalUrlParams({ unique_id: unique_id || anonymousId });
  const href = updateUrl(data.link, externalUrlParams);

  function handleClick(e) {
    if (data.type === ServiceButtonType.WATCH_NOW) {
      e.preventDefault();
      e.stopPropagation();
      popupCenter(href, window.innerWidth * 0.8, window.innerHeight * 0.8);

      onWatchNowClick();
    }

    if (data.type === ServiceButtonType.SIGN_UP) {
      const properties = {
        href,
        location: analyticsLocation,
        app_id: data.id,
        type: 'app',
        service_name: data.name,
        is_affiliate: !!data.is_affiliate,
        partner: partner?.partner_slug,
        partner_id: partner?.partner_id,
      };

      externalLink(properties);
    }
  }

  return (
    <Button
      color="primary"
      variant="contained"
      fullWidth
      href={href}
      target="_blank"
      onClick={handleClick}
      {...props}
    >
      {data.text}
    </Button>
  );
};

WatchButton.defaultProps = {
  partner: {},
  onWatchNowClick: () => {},
};

WatchButton.propTypes = {
  partner: PropTypes.object,
  data: PropTypes.object.isRequired,
  analyticsLocation: PropTypes.string,
  onWatchNowClick: PropTypes.func,
};

export default React.memo(WatchButton);
